import { styled, Typography, TypographyProps } from '@mui/material';

const InnerTypography = styled(Typography)(({ theme }) => ({
  display: '-webkit-box',
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  color: theme.palette.text.secondary,
}));

export const SearchHitDescriptionTypographyStyled = (props: TypographyProps) => (
  <InnerTypography {...props} variant="body2" />
);
